import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';

document.addEventListener("DOMContentLoaded", function () {
    const mainSwiperBreakPoint = window.matchMedia("(min-width: 768px)");
    const mainSwiperContainers = document.querySelectorAll(".type-section__slider");

    const mainSwiperInstances = new Map();

    function initOrDestroyMainSwipers() {
        mainSwiperContainers.forEach((slider) => {
            const container = slider.querySelector(".swiper-container");
            const nextBtn = slider.querySelector(".swiper-btn.next");
            const prevBtn = slider.querySelector(".swiper-btn.prev");
            const paginationEl = slider.querySelector(".type-section__count");
            const isActive = mainSwiperInstances.has(container);

            if (mainSwiperBreakPoint.matches) {
                if (isActive) {
                    mainSwiperInstances.get(container).destroy(true, true);
                    mainSwiperInstances.delete(container);
                }
            } else {
                if (!isActive) {
                    const swiper = new Swiper(container, {
                        modules: [Navigation],
                        spaceBetween: 16,
                        slidesPerView: 1,
                        loop: false,
                        autoHeight: true,

                        navigation: {
                            nextEl: nextBtn,
                            prevEl: prevBtn,
                        },

                        on: {
                            init: function () {
                                if (paginationEl) {
                                    paginationEl.textContent = `${this.realIndex + 1} / ${this.slides.length}`;
                                }
                            },
                            slideChange: function () {
                                if (paginationEl) {
                                    paginationEl.textContent = `${this.realIndex + 1} / ${this.slides.length}`;
                                }
                            },
                        },
                    });

                    mainSwiperInstances.set(container, swiper);
                }
            }
        });
    }

    initOrDestroyMainSwipers();
    mainSwiperBreakPoint.addEventListener("change", initOrDestroyMainSwipers);
});



